import { lazy, Suspense } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import PrivateRouteCustomer from "./PrivateRouteCustomer";

// web — lazy loaded so each page chunk is only downloaded when navigated to
const WebLogin = lazy(() => import("./WebPages/Login"));
const WebModules = lazy(() => import("./WebPages/Modules"));
const WebLessons = lazy(() => import("./WebPages/Lessons"));
const WebLevels = lazy(() => import("./WebPages/Levels"));
const PlayerPage = lazy(() => import("./WebPages/PlayerPage"));
const NotFound = lazy(() => import("./404/Index"));

export const PrefixPath = "";

function Navigation() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          {/* web Routes */}
          <Route path="/" element={<WebLogin />} />
          <Route
            path="/modules"
            element={
              <PrivateRouteCustomer>
                <WebModules />
              </PrivateRouteCustomer>
            }
          />
          <Route
            path="/levels"
            element={
              <PrivateRouteCustomer>
                <WebLevels />
              </PrivateRouteCustomer>
            }
          />
          <Route
            path="/lesson"
            element={
              <PrivateRouteCustomer>
                <WebLessons />
              </PrivateRouteCustomer>
            }
          />
          <Route
            path="/playerPage"
            element={
              <PrivateRouteCustomer>
                <PlayerPage />
              </PrivateRouteCustomer>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default Navigation;
